import { render } from "./albumfotos.vue?vue&type=template&id=68c7e9f5&scoped=true"
import script from "./albumfotos.vue?vue&type=script&lang=js"
export * from "./albumfotos.vue?vue&type=script&lang=js"

import "./albumfotos.vue?vue&type=style&index=0&id=68c7e9f5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68c7e9f5"]])

export default __exports__